var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whole"},[_c('div',{staticClass:"header"},[_c('HeadBar')],1),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"sidebar"},[_c('SlideBar')],1),_c('div',{staticClass:"mainContent"},[_c('AppMain')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }